<template>
  <router-link
      v-if="href"
      :to="href"
      :class="['app-button', theme, size, { 'app-button--disabled': disabled }]"
      :title="title"
      :target="target"
      data-button-link-cy
  >
    <span class="app-button__icon" v-if="icon">
      <Icon :name="icon"/>
    </span>
    <span class="app-button__text">{{ text }}</span>
  </router-link>
  <button
      v-else
      :type="type"
      :disabled="disabled"
      :class="['app-button', theme, size]"
      :title="title"
      :data-button-cy="type"
      @click="click"
  >
    <span class="app-button__icon" v-if="icon">
      <Icon :name="icon"/>
    </span>
    <span class="app-button__text">{{ text }}</span>
  </button>
</template>

<script>
import Icon from '@/components/Icon/Icon.vue';

export default {
  name: 'AppButton',
  components: { Icon },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    type() {
      return this.data.type || 'button';
    },
    href() {
      return this.data.href || false;
    },
    target() {
      return this.data.target || false;
    },
    text() {
      return this.data.text || '';
    },
    title() {
      return this.data.title || this.text;
    },
    disabled() {
      return this.data.disabled;
    },
    theme() {
      return this.data.theme
        ? `app-button--${this.data.theme}`
        : '';
    },
    icon() {
      return this.data.icon || false;
    },
    size() {
      return this.data.size
        ? `app-button--${this.data.size}`
        : '';
    },
  },
  methods: {
    click() {
      if (!this.disabled) {
        this.$emit('onClick');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "AppButton";
</style>
